;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import type { Locale } from '@/i18n/routing'
import type { VisualCopy } from './types'

/** Money, numbers and dates as each language writes them. */
export type VisualFormat = {
  /** "€ 3.900" / "€3,900" — and with cents, "€ 1.102,75" / "€1,102.75". */
  euro: (amount: number, cents?: boolean) => string
  /** Thousands as the language groups them: "2.693" / "2,693". */
  number: (value: number) => string
  /** "64,8%" / "64.8%". */
  percent: (value: number, decimals?: number) => string
  /** "15 juli" / "15 July". */
  dayMonth: (day: number) => string
  /** "16 juli 2026" / "16 July 2026". */
  fullDate: (day: number) => string
  /** "14 jul" / "14 Jul". */
  shortDate: (day: number) => string
  /** "donderdag 17 juli" / "Thursday 17 July". */
  weekdayDate: (day: number, weekdayIndex: number) => string
  /** "40,00 u" / "40.00 h". */
  hours: (value: number, decimals?: number) => string
  /** A bare decimal in the language's own notation: "5,50" / "5.50". */
  decimal: (value: number, decimals?: number) => string
}

export function formatFor(locale: Locale, copy: VisualCopy): VisualFormat {
  const dutch = locale === 'nl'
  const group = (whole: number) => whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, dutch ? '.' : ',')
  const decimal = (value: number, decimals: number) => {
    const fixed = value.toFixed(decimals)
    const [whole, fraction] = fixed.split('.')
    const grouped = group(Number(whole))
    return fraction ? `${grouped}${dutch ? ',' : '.'}${fraction}` : grouped
  }
  const monthWord = copy.period.monthLower.split(' ')[0]
  const year = copy.period.monthLower.split(' ')[1]

  return {
    euro: (amount, cents = false) =>
      dutch ? `€ ${decimal(amount, cents ? 2 : 0)}` : `€${decimal(amount, cents ? 2 : 0)}`,
    number: (value) => group(Math.round(value)),
    percent: (value, decimals = 1) => `${decimal(value, decimals)}%`,
    dayMonth: (day) => `${day} ${monthWord}`,
    fullDate: (day) => `${day} ${monthWord} ${year}`,
    shortDate: (day) => `${day} ${copy.monthsShort[6]}`,
    weekdayDate: (day, weekdayIndex) => `${copy.weekdays[weekdayIndex]} ${day} ${monthWord}`,
    hours: (value, decimals = 2) => `${decimal(value, decimals)} ${copy.word.hoursUnit}`,
    decimal: (value, decimals = 2) => decimal(value, decimals),
  }
}
